import * as React from "react";
import { forwardRef, memo } from "react";
const SvgLc = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 600 300", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { fill: "#6Cf", width: 600, height: 300 }), /* @__PURE__ */ React.createElement("polygon", { fill: "#FFF", points: "200,274 300,260 400,274 300,27" }), /* @__PURE__ */ React.createElement("polygon", { points: "213.5,274 300,260 386.5,274 300,60" }), /* @__PURE__ */ React.createElement("polygon", { fill: "#FCD116", points: "200,274 400,274 300,150" }));
const ForwardRef = forwardRef(SvgLc);
const Memo = memo(ForwardRef);
export default Memo;
